const statusList = [
  {
    value: 1,
    label: 'Виконано',
    color: '#0B78F9',
  },
  {
    value: 2,
    label: 'В роботі',
    color: '#1E0BF9',
  },
  {
    value: 3,
    label: 'Прибуло',
    color: '#900BF9',
  },
  {
    value: 4,
    label: 'Отримано',
    color: '#F90BB6',
  },
  {
    value: 5,
    label: 'Вороття',
    color: '#F9A00B',
  },
  {
    value: 6,
    label: 'Відміна',
    color: '#F90B0B',
  },
  {
    value: 7,
    label: 'У чернеці',
    color: '#9B9EAB',
  },
  
];

export default statusList;
